const DividerTheme = {
  baseStyle: {
    borderColor: 'inherit',
    color: 'separator.primary',
  },
  variants: {
    dashed: {
      borderStyle: 'dashed',
    },
    dotted: {
      borderStyle: 'dotted',
    },
    solid: {
      borderStyle: 'solid',
    },
  },
};

export default DividerTheme;
